// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import Circle from "../assets/Vector-1.svg";
// // // // import Collar from "../assets/Rectangle(1).png";
// // // // import J from "../assets/Vector.svg";
// // // // import { useNavigate, useLocation } from "react-router-dom";
// // // // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // // // export default function Navbar() {
// // // //   const navigate = useNavigate();
// // // //   const location = useLocation();

// // // //   const [isOpen, setIsOpen] = useState(false);
// // // //   const [showNavbar, setShowNavbar] = useState(true);

// // // //   const lastScrollY = useRef(0);
// // // //   const NAVBAR_HEIGHT = 80;

// // // //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// // // //   useEffect(() => {
// // // //     const handleScroll = () => {
// // // //       const currentScrollY = window.scrollY;

// // // //       if (currentScrollY < 10) {
// // // //         // Always show at top
// // // //         setShowNavbar(true);
// // // //       } else if (currentScrollY > lastScrollY.current) {
// // // //         // Scrolling down
// // // //         setShowNavbar(false);
// // // //         setIsOpen(false);
// // // //       } else {
// // // //         // Scrolling up
// // // //         setShowNavbar(true);
// // // //       }

// // // //       lastScrollY.current = currentScrollY;
// // // //     };

// // // //     window.addEventListener("scroll", handleScroll, { passive: true });
// // // //     return () => window.removeEventListener("scroll", handleScroll);
// // // //   }, []);

// // // //   /* ---------------- SMOOTH SCROLL ---------------- */
// // // //   const scrollToSection = (sectionId) => {
// // // //     const element = document.getElementById(sectionId);
// // // //     if (element) {
// // // //       const elementPosition =
// // // //         element.getBoundingClientRect().top + window.pageYOffset;
// // // //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// // // //       window.scrollTo({
// // // //         top: offsetPosition,
// // // //         behavior: "smooth",
// // // //       });
// // // //     }
// // // //   };

// // // //   const handleNavigation = (path, sectionId = null) => {
// // // //     if (sectionId) {
// // // //       if (location.pathname !== "/") {
// // // //         navigate("/");
// // // //         setTimeout(() => scrollToSection(sectionId), 150);
// // // //       } else {
// // // //         scrollToSection(sectionId);
// // // //       }
// // // //     } else {
// // // //       navigate(path);
// // // //     }
// // // //     setIsOpen(false);
// // // //   };

// // // //   const navItems = [
// // // //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// // // //     { name: "About Us", path: "/aboutUs" },
// // // //     { name: "AI Drafting", path: "/aiDrafting" },
// // // //     { name: "Subscription", path: "/subPlans" },
// // // //     { name: "Help", path: "/", sectionId: "help" },
// // // //   ];

// // // //   return (
// // // //     <>
// // // //       {/* NAVBAR */}
// // // //       <nav
// // // //         className={`bg-white 
// // // //           fixed top-0 left-0 w-full z-50  shadow-sm
// // // //           transition-transform duration-300 ease-out
// // // //           ${showNavbar ? "translate-y-0" : "-translate-y-full"}
// // // //         `}
// // // //       >
// // // //         <div className="flex items-center justify-between px-4 sm:px-6 py-4">
// // // //           {/* LOGO */}
// // // //           <div
// // // //             className="flex justify-center items-end gap-0.5 w-[120px] sm:w-[135px] h-[52px] cursor-pointer"
// // // //             onClick={() => navigate("/")}
// // // //           >
// // // //             <div className="relative w-[28px] h-[52px]">
// // // //               <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// // // //               <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// // // //               <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// // // //             </div>
// // // //             <span className="text-[#CB9F47] font-semibold text-[28px] leading-[140%]">
// // // //               urident
// // // //             </span>
// // // //           </div>

// // // //           {/* DESKTOP NAV */}
// // // //           <ul className="hidden md:flex flex-grow justify-center items-center gap-10">
// // // //             {navItems.map((item, index) => (
// // // //               <li key={index}>
// // // //                 <button
// // // //                   onClick={() => handleNavigation(item.path, item.sectionId)}
// // // //                   className="relative text-[#141414] font-semibold text-[18px] transition hover:text-[#CB9F47]
// // // //                   after:absolute after:left-1/2 after:bottom-[-3px] after:h-[2px] after:w-0 after:bg-black
// // // //                   after:transition-all after:duration-300 after:-translate-x-1/2 hover:after:w-full"
// // // //                 >
// // // //                   {item.name}
// // // //                 </button>
// // // //               </li>
// // // //             ))}
// // // //           </ul>

// // // //           {/* DESKTOP BUTTONS */}
// // // //           <div className="hidden md:flex gap-4">
// // // //             <button
// // // //               onClick={() => navigate("/portal")}
// // // //               className="bg-black text-white px-6 py-2 rounded-2xl font-semibold text-sm hover:scale-105 transition"
// // // //             >
// // // //               Explore Jurident
// // // //             </button>

// // // //             <div className="p-[2px] rounded-2xl bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] hover:scale-105 transition">
// // // //               <button
// // // //                 onClick={() => navigate("/demo")}
// // // //                 className="bg-white text-gray-900 px-6 py-2 rounded-2xl font-semibold text-sm"
// // // //               >
// // // //                 Book a Demo
// // // //               </button>
// // // //             </div>
// // // //           </div>

// // // //           {/* MOBILE TOGGLE */}
// // // //           <div className="md:hidden">
// // // //             <button onClick={() => setIsOpen(!isOpen)}>
// // // //               {isOpen ? (
// // // //                 <HiOutlineX className="w-6 h-6" />
// // // //               ) : (
// // // //                 <HiOutlineMenu className="w-6 h-6" />
// // // //               )}
// // // //             </button>
// // // //           </div>
// // // //         </div>
// // // //       </nav>

// // // //       {/* MOBILE MENU */}
// // // //       {isOpen && (
// // // //         <div className="fixed top-[80px] left-0 w-full bg-white z-40 shadow-xl md:hidden animate-slideDown">
// // // //           <div className="px-6 py-4">
// // // //             <ul className="flex flex-col gap-2">
// // // //               {navItems.map((item, index) => (
// // // //                 <li key={index}>
// // // //                   <button
// // // //                     onClick={() => handleNavigation(item.path, item.sectionId)}
// // // //                     className="w-full text-center text-lg py-2 rounded-lg hover:bg-gray-50"
// // // //                   >
// // // //                     {item.name}
// // // //                   </button>
// // // //                 </li>
// // // //               ))}
// // // //             </ul>

// // // //             <div className="mt-4 flex flex-col gap-3 items-center">
// // // //               <button
// // // //                 onClick={() => navigate("/portal")}
// // // //                 className="bg-black text-white py-2.5 px-6 rounded-full w-3/5"
// // // //               >
// // // //                 Explore Jurident
// // // //               </button>

// // // //               <button
// // // //                 onClick={() => {
// // // //                   navigate("/demo");
// // // //                   setIsOpen(false);
// // // //                 }}
// // // //                 className="bg-white border text-[#23216E] py-2.5 px-6 rounded-full w-3/5"
// // // //               >
// // // //                 Book Demo
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* ANIMATION */}
// // // //       <style jsx>{`
// // // //         @keyframes slideDown {
// // // //           from {
// // // //             opacity: 0;
// // // //             transform: translateY(-10px);
// // // //           }
// // // //           to {
// // // //             opacity: 1;
// // // //             transform: translateY(0);
// // // //           }
// // // //         }
// // // //         .animate-slideDown {
// // // //           animation: slideDown 0.25s ease-out;
// // // //         }
// // // //       `}</style>
// // // //     </>
// // // //   );
// // // // }























// // // import React, { useState, useEffect, useRef } from "react";
// // // import Circle from "../assets/Vector-1.svg";
// // // import Collar from "../assets/Rectangle(1).png";
// // // import J from "../assets/Vector.svg";
// // // import { useNavigate, useLocation } from "react-router-dom";
// // // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // // export default function Navbar() {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();

// // //   const [isOpen, setIsOpen] = useState(false);
// // //   const [showNavbar, setShowNavbar] = useState(true);
// // //   const [scrolled, setScrolled] = useState(false);

// // //   const lastScrollY = useRef(0);
// // //   const NAVBAR_HEIGHT = 80;

// // //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// // //   useEffect(() => {
// // //     const handleScroll = () => {
// // //       const currentScrollY = window.scrollY;

// // //       setScrolled(currentScrollY > 20);

// // //       if (currentScrollY < 10) {
// // //         setShowNavbar(true);
// // //       } else if (currentScrollY > lastScrollY.current) {
// // //         setShowNavbar(false);
// // //         setIsOpen(false);
// // //       } else {
// // //         setShowNavbar(true);
// // //       }

// // //       lastScrollY.current = currentScrollY;
// // //     };

// // //     window.addEventListener("scroll", handleScroll, { passive: true });
// // //     return () => window.removeEventListener("scroll", handleScroll);
// // //   }, []);

// // //   /* ---------------- SMOOTH SCROLL ---------------- */
// // //   const scrollToSection = (sectionId) => {
// // //     const element = document.getElementById(sectionId);
// // //     if (element) {
// // //       const elementPosition =
// // //         element.getBoundingClientRect().top + window.pageYOffset;
// // //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// // //       window.scrollTo({
// // //         top: offsetPosition,
// // //         behavior: "smooth",
// // //       });
// // //     }
// // //   };

// // //   const handleNavigation = (path, sectionId = null) => {
// // //     if (sectionId) {
// // //       if (location.pathname !== "/") {
// // //         navigate("/");
// // //         setTimeout(() => scrollToSection(sectionId), 150);
// // //       } else {
// // //         scrollToSection(sectionId);
// // //       }
// // //     } else {
// // //       navigate(path);
// // //     }
// // //     setIsOpen(false);
// // //   };

// // //   const navItems = [
// // //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// // //     { name: "About Us", path: "/aboutUs" },
// // //     { name: "AI Drafting", path: "/aiDrafting" },
// // //     { name: "Subscription", path: "/subPlans" },
// // //     { name: "Help", path: "/", sectionId: "help" },
// // //   ];

// // //   return (
// // //     <>
// // //       {/* NAVBAR */}
// // //       <nav
// // //         className={`fixed top-0 left-0 w-full z-50 transition-all duration-300
// // //         ${showNavbar ? "translate-y-0" : "-translate-y-full"}
// // //         ${scrolled
// // //           ? "backdrop-blur-xl bg-white/85 shadow-lg"
// // //           : "bg-white"}
// // //         `}
// // //       >
// // //         <div className="flex items-center justify-between px-4 sm:px-6 py-4">

// // //           {/* LOGO */}
// // //           <div
// // //             onClick={() => navigate("/")}
// // //             className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// // //           >
// // //             <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// // //               <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// // //               <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// // //               <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// // //             </div>
// // //             <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// // //               urident
// // //             </span>
// // //           </div>

// // //           {/* DESKTOP NAV */}
// // //           <ul className="hidden md:flex flex-grow justify-center gap-10">
// // //             {navItems.map((item, index) => (
// // //               <li key={index}>
// // //                 <button
// // //                   onClick={() => handleNavigation(item.path, item.sectionId)}
// // //                   className="relative text-[#141414] font-semibold text-[17px]
// // //                   transition-all duration-300
// // //                   hover:text-[#CB9F47]
// // //                   after:absolute after:left-1/2 after:-bottom-1
// // //                   after:h-[2px] after:w-0 after:bg-gradient-to-r after:from-[#CB9F47] after:to-black
// // //                   after:transition-all after:duration-300
// // //                   after:-translate-x-1/2 hover:after:w-full"
// // //                 >
// // //                   {item.name}
// // //                 </button>
// // //               </li>
// // //             ))}
// // //           </ul>

// // //           {/* DESKTOP CTA */}
// // //           <div className="hidden md:flex gap-4">
// // //             <button
// // //               onClick={() => navigate("/portal")}
// // //               className="bg-black text-white px-6 py-2 rounded-2xl font-semibold text-sm
// // //               transition-all duration-300 hover:scale-105 hover:shadow-lg active:scale-95"
// // //             >
// // //               Explore Jurident
// // //             </button>

// // //             <div className="p-[2px] rounded-2xl bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] hover:scale-105 transition">
// // //               <button
// // //                 onClick={() => navigate("/demo")}
// // //                 className="bg-white px-6 py-2 rounded-2xl font-semibold text-sm
// // //                 hover:bg-transparent hover:text-white transition"
// // //               >
// // //                 Book a Demo
// // //               </button>
// // //             </div>
// // //           </div>

// // //           {/* MOBILE TOGGLE */}
// // //           <div className="md:hidden">
// // //             <button onClick={() => setIsOpen(!isOpen)}>
// // //               {isOpen ? (
// // //                 <HiOutlineX className="w-6 h-6" />
// // //               ) : (
// // //                 <HiOutlineMenu className="w-6 h-6" />
// // //               )}
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </nav>

// // //       {/* MOBILE MENU */}
// // //       {isOpen && (
// // //         <div className="fixed top-[80px] left-0 w-full bg-white/95 backdrop-blur-xl z-40 shadow-xl md:hidden animate-slideDown">
// // //           <div className="px-6 py-5">
// // //             <ul className="flex flex-col gap-2">
// // //               {navItems.map((item, index) => (
// // //                 <li key={index}>
// // //                   <button
// // //                     onClick={() => handleNavigation(item.path, item.sectionId)}
// // //                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-gray-100 transition"
// // //                   >
// // //                     {item.name}
// // //                   </button>
// // //                 </li>
// // //               ))}
// // //             </ul>

// // //             <div className="mt-6 flex flex-col gap-3 items-center">
// // //               <button
// // //                 onClick={() => navigate("/portal")}
// // //                 className="bg-black text-white py-3 rounded-full w-3/5"
// // //               >
// // //                 Explore Jurident
// // //               </button>

// // //               <button
// // //                 onClick={() => {
// // //                   navigate("/demo");
// // //                   setIsOpen(false);
// // //                 }}
// // //                 className="border py-3 rounded-full w-3/5 text-[#23216E]"
// // //               >
// // //                 Book Demo
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* MOBILE MENU ANIMATION */}
// // //       <style>{`
// // //         @keyframes slideDown {
// // //           from {
// // //             opacity: 0;
// // //             transform: translateY(-12px);
// // //           }
// // //           to {
// // //             opacity: 1;
// // //             transform: translateY(0);
// // //           }
// // //         }
// // //         .animate-slideDown {
// // //           animation: slideDown 0.3s ease-out;
// // //         }
// // //       `}</style>
// // //     </>
// // //   );
// // // }














// // // import React, { useState, useEffect, useRef } from "react";
// // // import Circle from "../assets/Vector-1.svg";
// // // import Collar from "../assets/Rectangle(1).png";
// // // import J from "../assets/Vector.svg";
// // // import { useNavigate, useLocation } from "react-router-dom";
// // // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // // export default function Navbar() {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();

// // //   const [isOpen, setIsOpen] = useState(false);
// // //   const [showNavbar, setShowNavbar] = useState(true);
// // //   const [scrolled, setScrolled] = useState(false);

// // //   const lastScrollY = useRef(0);
// // //   const NAVBAR_HEIGHT = 80;

// // //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// // //   useEffect(() => {
// // //     const handleScroll = () => {
// // //       const currentScrollY = window.scrollY;

// // //       setScrolled(currentScrollY > 20);

// // //       if (currentScrollY < 10) {
// // //         setShowNavbar(true);
// // //       } else if (currentScrollY > lastScrollY.current) {
// // //         setShowNavbar(false);
// // //         setIsOpen(false);
// // //       } else {
// // //         setShowNavbar(true);
// // //       }

// // //       lastScrollY.current = currentScrollY;
// // //     };

// // //     window.addEventListener("scroll", handleScroll, { passive: true });
// // //     return () => window.removeEventListener("scroll", handleScroll);
// // //   }, []);

// // //   /* ---------------- SMOOTH SCROLL ---------------- */
// // //   const scrollToSection = (sectionId) => {
// // //     const element = document.getElementById(sectionId);
// // //     if (element) {
// // //       const elementPosition =
// // //         element.getBoundingClientRect().top + window.pageYOffset;
// // //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// // //       window.scrollTo({
// // //         top: offsetPosition,
// // //         behavior: "smooth",
// // //       });
// // //     }
// // //   };

// // //   const handleNavigation = (path, sectionId = null) => {
// // //     if (sectionId) {
// // //       if (location.pathname !== "/") {
// // //         navigate("/");
// // //         setTimeout(() => scrollToSection(sectionId), 150);
// // //       } else {
// // //         scrollToSection(sectionId);
// // //       }
// // //     } else {
// // //       navigate(path);
// // //     }
// // //     setIsOpen(false);
// // //   };

// // //   const navItems = [
// // //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// // //     { name: "About Us", path: "/aboutUs" },
// // //     { name: "AI Drafting", path: "/aiDrafting" },
// // //     { name: "Subscription", path: "/subPlans" },
// // //     { name: "Help", path: "/", sectionId: "help" },
// // //   ];

// // //   return (
// // //     <>
// // //       {/* NAVBAR */}
// // //       <nav
// // //         className={`fixed top-0 left-0 w-full z-50 transition-all duration-300
// // //         ${showNavbar ? "translate-y-0" : "-translate-y-full"}
// // //         ${scrolled
// // //           ? "backdrop-blur-xl bg-white/85 shadow-lg"
// // //           : "bg-white"}
// // //         `}
// // //       >
// // //         <div className="flex items-center justify-between px-4 sm:px-6 py-4">

// // //           {/* LOGO */}
// // //           <div
// // //             onClick={() => navigate("/")}
// // //             className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// // //           >
// // //             <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// // //               <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// // //               <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// // //               <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// // //             </div>
// // //             <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// // //               urident
// // //             </span>
// // //           </div>

// // //           {/* DESKTOP NAV */}
// // //           <ul className="hidden md:flex flex-grow justify-center gap-10">
// // //             {navItems.map((item, index) => (
// // //               <li key={index}>
// // //                 <button
// // //                   onClick={() => handleNavigation(item.path, item.sectionId)}
// // //                   className="relative text-[#141414] font-semibold text-[17px]
// // //                   transition-all duration-300
// // //                   hover:text-[#CB9F47]
// // //                   after:absolute after:left-1/2 after:-bottom-1
// // //                   after:h-[2px] after:w-0 after:bg-gradient-to-r after:from-[#CB9F47] after:to-black
// // //                   after:transition-all after:duration-300
// // //                   after:-translate-x-1/2 hover:after:w-full"
// // //                 >
// // //                   {item.name}
// // //                 </button>
// // //               </li>
// // //             ))}
// // //           </ul>

// // //           {/* DESKTOP CTA */}
// // //           <div className="hidden md:flex gap-4">
// // //             <button
// // //               onClick={() => navigate("/portal")}
// // //               className="bg-black text-white px-6 py-2 rounded-2xl font-semibold text-sm
// // //               transition-all duration-300 hover:scale-105 hover:shadow-lg active:scale-95"
// // //             >
// // //               Explore Jurident
// // //             </button>

// // //             {/* ✅ ONLY CHANGE: text-black added */}
// // //             <div className="p-[2px] rounded-2xl bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] hover:scale-105 transition">
// // //               <button
// // //                 onClick={() => navigate("/demo")}
// // //                 className="bg-white text-black px-6 py-2 rounded-2xl font-semibold text-sm
// // //                 hover:bg-transparent hover:text-white transition"
// // //               >
// // //                 Book Demo
// // //               </button>
// // //             </div>
// // //           </div>

// // //           {/* MOBILE TOGGLE */}
// // //           <div className="md:hidden">
// // //             <button onClick={() => setIsOpen(!isOpen)}>
// // //               {isOpen ? (
// // //                 <HiOutlineX className="w-6 h-6" />
// // //               ) : (
// // //                 <HiOutlineMenu className="w-6 h-6" />
// // //               )}
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </nav>

// // //       {/* MOBILE MENU */}
// // //       {isOpen && (
// // //         <div className="fixed top-[80px] left-0 w-full bg-white/95 backdrop-blur-xl z-40 shadow-xl md:hidden animate-slideDown">
// // //           <div className="px-6 py-5">
// // //             <ul className="flex flex-col gap-2">
// // //               {navItems.map((item, index) => (
// // //                 <li key={index}>
// // //                   <button
// // //                     onClick={() => handleNavigation(item.path, item.sectionId)}
// // //                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-gray-100 transition"
// // //                   >
// // //                     {item.name}
// // //                   </button>
// // //                 </li>
// // //               ))}
// // //             </ul>

// // //             <div className="mt-6 flex flex-col gap-3 items-center">
// // //               <button
// // //                 onClick={() => navigate("/portal")}
// // //                 className="bg-black text-white py-3 rounded-full w-3/5"
// // //               >
// // //                 Explore Jurident
// // //               </button>

// // //               <button
// // //                 onClick={() => {
// // //                   navigate("/demo");
// // //                   setIsOpen(false);
// // //                 }}
// // //                 className="border py-3 rounded-full w-3/5 text-[#23216E]"
// // //               >
// // //                 Book Demo
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* MOBILE MENU ANIMATION */}
// // //       <style>{`
// // //         @keyframes slideDown {
// // //           from {
// // //             opacity: 0;
// // //             transform: translateY(-12px);
// // //           }
// // //           to {
// // //             opacity: 1;
// // //             transform: translateY(0);
// // //           }
// // //         }
// // //         .animate-slideDown {
// // //           animation: slideDown 0.3s ease-out;
// // //         }
// // //       `}</style>
// // //     </>
// // //   );
// // // }















// // import React, { useState, useEffect, useRef } from "react";
// // import Circle from "../assets/Vector-1.svg";
// // import Collar from "../assets/Rectangle(1).png";
// // import J from "../assets/Vector.svg";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // export default function Navbar() {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [isOpen, setIsOpen] = useState(false);
// //   const [showNavbar, setShowNavbar] = useState(true);
// //   const [scrolled, setScrolled] = useState(false);

// //   const lastScrollY = useRef(0);
// //   const NAVBAR_HEIGHT = 80;

// //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;

// //       setScrolled(currentScrollY > 20);

// //       if (currentScrollY < 10) {
// //         setShowNavbar(true);
// //       } else if (currentScrollY > lastScrollY.current) {
// //         setShowNavbar(false);
// //         setIsOpen(false);
// //       } else {
// //         setShowNavbar(true);
// //       }

// //       lastScrollY.current = currentScrollY;
// //     };

// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   /* ---------------- SMOOTH SCROLL ---------------- */
// //   const scrollToSection = (sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) {
// //       const elementPosition =
// //         element.getBoundingClientRect().top + window.pageYOffset;
// //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// //       window.scrollTo({
// //         top: offsetPosition,
// //         behavior: "smooth",
// //       });
// //     }
// //   };

// //   const handleNavigation = (path, sectionId = null) => {
// //     if (sectionId) {
// //       if (location.pathname !== "/") {
// //         navigate("/");
// //         setTimeout(() => scrollToSection(sectionId), 150);
// //       } else {
// //         scrollToSection(sectionId);
// //       }
// //     } else {
// //       navigate(path);
// //     }
// //     setIsOpen(false);
// //   };

// //   const navItems = [
// //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// //     { name: "About Us", path: "/aboutUs" },
// //     { name: "AI Drafting", path: "/aiDrafting" },
// //     { name: "Subscription", path: "/subPlans" },
// //     { name: "Help", path: "/", sectionId: "help" },
// //   ];

// //   return (
// //     <>
// //       {/* FLOATING NAVBAR WRAPPER */}
// //       <div
// //         className={`fixed top-4 left-0 w-full z-50 transition-all duration-300
// //         ${showNavbar ? "translate-y-0" : "-translate-y-24"}
// //         `}
// //       >
// //         <nav
// //           className={`
// //             mx-auto max-w-[1280px]
// //             rounded-3xl
// //             transition-all duration-300
// //             ${
// //               scrolled
// //                 ? "backdrop-blur-xl bg-white/85 shadow-[0_20px_60px_rgba(0,0,0,0.12)]"
// //                 : "bg-white shadow-[0_10px_30px_rgba(0,0,0,0.08)]"
// //             }
// //           `}
// //         >
// //           <div className="flex items-center justify-between px-4 sm:px-6 py-4">

// //             {/* LOGO */}
// //             <div
// //               onClick={() => navigate("/")}
// //               className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// //             >
// //               <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// //                 <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// //                 <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// //                 <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// //               </div>
// //               <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// //                 urident
// //               </span>
// //             </div>

// //             {/* DESKTOP NAV */}
// //             <ul className="hidden md:flex flex-grow justify-center gap-10">
// //               {navItems.map((item, index) => (
// //                 <li key={index}>
// //                   <button
// //                     onClick={() => handleNavigation(item.path, item.sectionId)}
// //                     className="relative text-[#141414] font-semibold text-[17px]
// //                     transition-all duration-300
// //                     hover:text-[#CB9F47]
// //                     after:absolute after:left-1/2 after:-bottom-1
// //                     after:h-[2px] after:w-0 after:bg-gradient-to-r after:from-[#CB9F47] after:to-black
// //                     after:transition-all after:duration-300
// //                     after:-translate-x-1/2 hover:after:w-full"
// //                   >
// //                     {item.name}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>

// //             {/* DESKTOP CTA */}
// //             <div className="hidden md:flex gap-4">
// //               <button
// //                 onClick={() => navigate("/portal")}
// //                 className="bg-black text-white px-6 py-2 rounded-2xl font-semibold text-sm
// //                 transition-all duration-300 hover:scale-105 hover:shadow-lg active:scale-95"
// //               >
// //                 Explore Jurident
// //               </button>

// //               <div className="p-[2px] rounded-2xl bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] hover:scale-105 transition">
// //                 <button
// //                   onClick={() => navigate("/demo")}
// //                   className="bg-white text-black px-6 py-2 rounded-2xl font-semibold text-sm
// //                   hover:bg-transparent hover:text-white transition"
// //                 >
// //                   Book Demo
// //                 </button>
// //               </div>
// //             </div>

// //             {/* MOBILE TOGGLE */}
// //             <div className="md:hidden">
// //               <button onClick={() => setIsOpen(!isOpen)}>
// //                 {isOpen ? (
// //                   <HiOutlineX className="w-6 h-6" />
// //                 ) : (
// //                   <HiOutlineMenu className="w-6 h-6" />
// //                 )}
// //               </button>
// //             </div>
// //           </div>
// //         </nav>
// //       </div>

// //       {/* MOBILE MENU */}
// //       {isOpen && (
// //         <div className="fixed top-[96px] left-4 right-4 bg-white/95 backdrop-blur-xl z-40 shadow-xl md:hidden rounded-3xl animate-slideDown">
// //           <div className="px-6 py-5">
// //             <ul className="flex flex-col gap-2">
// //               {navItems.map((item, index) => (
// //                 <li key={index}>
// //                   <button
// //                     onClick={() => handleNavigation(item.path, item.sectionId)}
// //                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-gray-100 transition"
// //                   >
// //                     {item.name}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>

// //             <div className="mt-6 flex flex-col gap-3 items-center">
// //               <button
// //                 onClick={() => navigate("/portal")}
// //                 className="bg-black text-white py-3 rounded-full w-3/5"
// //               >
// //                 Explore Jurident
// //               </button>

// //               <button
// //                 onClick={() => {
// //                   navigate("/demo");
// //                   setIsOpen(false);
// //                 }}
// //                 className="border py-3 rounded-full w-3/5 text-[#23216E]"
// //               >
// //                 Book Demo
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* MOBILE MENU ANIMATION */}
// //       <style>{`
// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-12px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //         .animate-slideDown {
// //           animation: slideDown 0.3s ease-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // }



























// // import React, { useState, useEffect, useRef } from "react";
// // import Circle from "../assets/Vector-1.svg";
// // import Collar from "../assets/Rectangle(1).png";
// // import J from "../assets/Vector.svg";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // export default function Navbar() {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [isOpen, setIsOpen] = useState(false);
// //   const [showNavbar, setShowNavbar] = useState(true);
// //   const [scrolled, setScrolled] = useState(false);

// //   const lastScrollY = useRef(0);
// //   const NAVBAR_HEIGHT = 80;

// //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;

// //       setScrolled(currentScrollY > 20);

// //       if (currentScrollY < 10) {
// //         setShowNavbar(true);
// //       } else if (currentScrollY > lastScrollY.current) {
// //         setShowNavbar(false);
// //         setIsOpen(false);
// //       } else {
// //         setShowNavbar(true);
// //       }

// //       lastScrollY.current = currentScrollY;
// //     };

// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   /* ---------------- SMOOTH SCROLL ---------------- */
// //   const scrollToSection = (sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) {
// //       const elementPosition =
// //         element.getBoundingClientRect().top + window.pageYOffset;
// //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// //       window.scrollTo({
// //         top: offsetPosition,
// //         behavior: "smooth",
// //       });
// //     }
// //   };

// //   const handleNavigation = (path, sectionId = null) => {
// //     if (sectionId) {
// //       if (location.pathname !== "/") {
// //         navigate("/");
// //         setTimeout(() => scrollToSection(sectionId), 150);
// //       } else {
// //         scrollToSection(sectionId);
// //       }
// //     } else {
// //       navigate(path);
// //     }
// //     setIsOpen(false);
// //   };

// //   const navItems = [
// //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// //     { name: "About Us", path: "/aboutUs" },
// //     { name: "AI Drafting", path: "/aiDrafting" },
// //     { name: "Subscription", path: "/subPlans" },
// //     { name: "Help", path: "/", sectionId: "help" },
// //   ];

// //   return (
// //     <>
// //       {/* FLOATING WRAPPER */}
// //       <div
// //         className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
// //         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}
// //         `}
// //       >
// //         <div className="px-4 sm:px-6">
// //           {/* Glass Border Wrapper */}
// //           <div className="mx-auto max-w-[1300px] relative">

// //             {/* Gradient Glow Border */}
// //             <div className="absolute inset-0 rounded-3xl p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

// //             {/* Main Navbar */}
// //             <nav
// //               className={`
// //                 relative rounded-3xl
// //                 backdrop-blur-2xl
// //                 transition-all duration-500
// //                 ${
// //                   scrolled
// //                     ? "bg-white/80 shadow-[0_25px_80px_rgba(0,0,0,0.15)]"
// //                     : "bg-white/70 shadow-[0_15px_50px_rgba(0,0,0,0.10)]"
// //                 }
// //               `}
// //             >
// //               <div className="flex items-center justify-between px-6 py-4">

// //                 {/* LOGO */}
// //                 <div
// //                   onClick={() => navigate("/")}
// //                   className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// //                 >
// //                   <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// //                     <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// //                     <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// //                     <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// //                   </div>
// //                   <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// //                     urident
// //                   </span>
// //                 </div>

// //                 {/* DESKTOP NAV */}
// //                 <ul className="hidden md:flex flex-grow justify-center gap-10">
// //                   {navItems.map((item, index) => (
// //                     <li key={index}>
// //                       <button
// //                         onClick={() =>
// //                           handleNavigation(item.path, item.sectionId)
// //                         }
// //                         className="relative text-[#141414] font-medium text-[16px]
// //                         transition-all duration-300
// //                         hover:text-[#CB9F47]
// //                         after:absolute after:left-1/2 after:-bottom-1
// //                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
// //                         after:transition-all after:duration-300
// //                         after:-translate-x-1/2 hover:after:w-full"
// //                       >
// //                         {item.name}
// //                       </button>
// //                     </li>
// //                   ))}
// //                 </ul>

// //                 {/* DESKTOP CTA */}
// //                 <div className="hidden md:flex gap-4 items-center">

// //                   <button
// //                     onClick={() => navigate("/portal")}
// //                     className="bg-black text-white px-6 py-2.5 rounded-2xl font-medium text-sm
// //                     transition-all duration-300
// //                     hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
// //                     active:scale-95"
// //                   >
// //                     Explore Jurident
// //                   </button>

// //                   <div className="p-[1px] rounded-2xl bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
// //                     <button
// //                       onClick={() => navigate("/demo")}
// //                       className="bg-white text-black px-6 py-2.5 rounded-2xl font-medium text-sm
// //                       transition-all duration-300
// //                       hover:bg-transparent hover:text-white"
// //                     >
// //                       Book Demo
// //                     </button>
// //                   </div>
// //                 </div>

// //                 {/* MOBILE TOGGLE */}
// //                 <div className="md:hidden">
// //                   <button onClick={() => setIsOpen(!isOpen)}>
// //                     {isOpen ? (
// //                       <HiOutlineX className="w-6 h-6" />
// //                     ) : (
// //                       <HiOutlineMenu className="w-6 h-6" />
// //                     )}
// //                   </button>
// //                 </div>
// //               </div>
// //             </nav>
// //           </div>
// //         </div>
// //       </div>

// //       {/* MOBILE MENU */}
// //       {isOpen && (
// //         <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
// //           <div className="px-6 py-6">
// //             <ul className="flex flex-col gap-4">
// //               {navItems.map((item, index) => (
// //                 <li key={index}>
// //                   <button
// //                     onClick={() =>
// //                       handleNavigation(item.path, item.sectionId)
// //                     }
// //                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
// //                   >
// //                     {item.name}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>

// //             <div className="mt-6 flex flex-col gap-4 items-center">
// //               <button
// //                 onClick={() => navigate("/portal")}
// //                 className="bg-black text-white py-3 rounded-full w-4/5"
// //               >
// //                 Explore Jurident
// //               </button>

// //               <button
// //                 onClick={() => {
// //                   navigate("/demo");
// //                   setIsOpen(false);
// //                 }}
// //                 className="border py-3 rounded-full w-4/5 text-[#23216E]"
// //               >
// //                 Book Demo
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <style>{`
// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //         .animate-slideDown {
// //           animation: slideDown 0.35s ease-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // }

















// // import React, { useState, useEffect, useRef } from "react";
// // import Circle from "../assets/Vector-1.svg";
// // import Collar from "../assets/Rectangle(1).png";
// // import J from "../assets/Vector.svg";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // export default function Navbar() {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [isOpen, setIsOpen] = useState(false);
// //   const [showNavbar, setShowNavbar] = useState(true);
// //   const [scrolled, setScrolled] = useState(false);

// //   const lastScrollY = useRef(0);
// //   const NAVBAR_HEIGHT = 80;

// //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;

// //       setScrolled(currentScrollY > 20);

// //       if (currentScrollY < 10) {
// //         setShowNavbar(true);
// //       } else if (currentScrollY > lastScrollY.current) {
// //         setShowNavbar(false);
// //         setIsOpen(false);
// //       } else {
// //         setShowNavbar(true);
// //       }

// //       lastScrollY.current = currentScrollY;
// //     };

// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   /* ---------------- SMOOTH SCROLL ---------------- */
// //   const scrollToSection = (sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) {
// //       const elementPosition =
// //         element.getBoundingClientRect().top + window.pageYOffset;
// //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// //       window.scrollTo({
// //         top: offsetPosition,
// //         behavior: "smooth",
// //       });
// //     }
// //   };

// //   const handleNavigation = (path, sectionId = null) => {
// //     if (sectionId) {
// //       if (location.pathname !== "/") {
// //         navigate("/");
// //         setTimeout(() => scrollToSection(sectionId), 150);
// //       } else {
// //         scrollToSection(sectionId);
// //       }
// //     } else {
// //       navigate(path);
// //     }
// //     setIsOpen(false);
// //   };

// //   const navItems = [
// //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// //     { name: "About Us", path: "/aboutUs" },
// //     { name: "AI Drafting", path: "/aiDrafting" },
// //     { name: "Subscription", path: "/subPlans" },
// //     { name: "Help", path: "/", sectionId: "help" },
// //   ];

// //   return (
// //     <>
// //       {/* FLOATING WRAPPER */}
// //       <div
// //         className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
// //         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
// //       >
// //         <div className="px-4 sm:px-6">
// //           <div className="mx-auto max-w-[1300px] relative">

// //             {/* Gradient Glow Border (UNCHANGED) */}
// //             <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

// //             {/* MAIN NAVBAR */}
// //             <nav
// //               className={`
// //                 relative rounded-full
// //                 backdrop-blur-xl
// //                 transition-all duration-500
// //                 ${
// //                   scrolled
// //                     ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
// //                     : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
// //                 }
// //               `}
// //             >
// //               <div className="flex items-center justify-between px-8 py-3">

// //                 {/* LOGO */}
// //                 <div
// //                   onClick={() => navigate("/")}
// //                   className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// //                 >
// //                   <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// //                     <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// //                     <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// //                     <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// //                   </div>
// //                   <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// //                     urident
// //                   </span>
// //                 </div>

// //                 {/* DESKTOP NAV */}
// //                 <ul className="hidden md:flex flex-grow justify-center gap-8">
// //                   {navItems.map((item, index) => (
// //                     <li key={index}>
// //                       <button
// //                         onClick={() =>
// //                           handleNavigation(item.path, item.sectionId)
// //                         }
// //                         className="relative text-[#141414] font-medium text-[16px]
// //                         transition-all duration-300
// //                         hover:text-[#CB9F47]
// //                         after:absolute after:left-1/2 after:-bottom-1
// //                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
// //                         after:transition-all after:duration-300
// //                         after:-translate-x-1/2 hover:after:w-full"
// //                       >
// //                         {item.name}
// //                       </button>
// //                     </li>
// //                   ))}
// //                 </ul>

// //                 {/* DESKTOP CTA (UNCHANGED CONTENT) */}
// //                 <div className="hidden md:flex gap-4 items-center">

// //                   <button
// //                     onClick={() => navigate("/portal")}
// //                     className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
// //                     transition-all duration-300
// //                     hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
// //                     active:scale-95"
// //                   >
// //                     Explore Jurident
// //                   </button>

// //                   <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
// //                     <button
// //                       onClick={() => navigate("/demo")}
// //                       className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
// //                       transition-all duration-300
// //                       hover:bg-transparent hover:text-white"
// //                     >
// //                       Book Demo
// //                     </button>
// //                   </div>
// //                 </div>

// //                 {/* MOBILE TOGGLE */}
// //                 <div className="md:hidden">
// //                   <button onClick={() => setIsOpen(!isOpen)}>
// //                     {isOpen ? (
// //                       <HiOutlineX className="w-6 h-6" />
// //                     ) : (
// //                       <HiOutlineMenu className="w-6 h-6" />
// //                     )}
// //                   </button>
// //                 </div>

// //               </div>
// //             </nav>
// //           </div>
// //         </div>
// //       </div>

// //       {/* MOBILE MENU (UNCHANGED) */}
// //       {isOpen && (
// //         <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
// //           <div className="px-6 py-6">
// //             <ul className="flex flex-col gap-4">
// //               {navItems.map((item, index) => (
// //                 <li key={index}>
// //                   <button
// //                     onClick={() =>
// //                       handleNavigation(item.path, item.sectionId)
// //                     }
// //                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
// //                   >
// //                     {item.name}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>

// //             <div className="mt-6 flex flex-col gap-4 items-center">
// //               <button
// //                 onClick={() => navigate("/portal")}
// //                 className="bg-black text-white py-3 rounded-full w-4/5"
// //               >
// //                 Explore Jurident
// //               </button>

// //               <button
// //                 onClick={() => {
// //                   navigate("/demo");
// //                   setIsOpen(false);
// //                 }}
// //                 className="border py-3 rounded-full w-4/5 text-[#23216E]"
// //               >
// //                 Book Demo
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <style>{`
// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //         .animate-slideDown {
// //           animation: slideDown 0.35s ease-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // }




























// // //final code
// // import React, { useState, useEffect, useRef } from "react";
// // import Circle from "../assets/Vector-1.svg";
// // import Collar from "../assets/Rectangle(1).png";
// // import J from "../assets/Vector.svg";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { HiOutlineMenu, HiOutlineX, HiArrowUp } from "react-icons/hi";

// // export default function Navbar() {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const isHomePage = location.pathname === "/";

// //   const [isOpen, setIsOpen] = useState(false);
// //   const [showNavbar, setShowNavbar] = useState(true);
// //   const [scrolled, setScrolled] = useState(false);

// //   const lastScrollY = useRef(0);
// //   const NAVBAR_HEIGHT = 80;

// //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;

// //       setScrolled(currentScrollY > 20);

// //       if (currentScrollY < 10) {
// //         setShowNavbar(true);
// //       } else if (currentScrollY > lastScrollY.current) {
// //         setShowNavbar(false);
// //         setIsOpen(false);
// //       } else {
// //         setShowNavbar(true);
// //       }

// //       lastScrollY.current = currentScrollY;
// //     };

// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   /* ---------------- SCROLL TO TOP ---------------- */
// //   const scrollToTop = () => {
// //     window.scrollTo({
// //       top: 0,
// //       behavior: "smooth",
// //     });
// //   };

// //   /* ---------------- SMOOTH SCROLL ---------------- */
// //   const scrollToSection = (sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) {
// //       const elementPosition =
// //         element.getBoundingClientRect().top + window.pageYOffset;
// //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// //       window.scrollTo({
// //         top: offsetPosition,
// //         behavior: "smooth",
// //       });
// //     }
// //   };

// //   const handleNavigation = (path, sectionId = null) => {
// //     if (sectionId) {
// //       if (location.pathname !== "/") {
// //         navigate("/");
// //         setTimeout(() => scrollToSection(sectionId), 150);
// //       } else {
// //         scrollToSection(sectionId);
// //       }
// //     } else {
// //       navigate(path);
// //     }
// //     setIsOpen(false);
// //   };

// //   const navItems = [
// //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// //     { name: "About Us", path: "/aboutUs" },
// //     { name: "AI Drafting", path: "/aiDrafting" },
// //     { name: "Subscription", path: "/subPlans" },
// //     { name: "Help", path: "/", sectionId: "help" },
// //   ];

// //   return (
// //     <>
// //       {isHomePage ? (
// //         <>
// //           {/* FLOATING WRAPPER */}
// //           <div
// //             className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
// //         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
// //           >
// //             <div className="px-4 sm:px-6">
// //               <div className="mx-auto max-w-[1300px] relative">

// //                 {/* Gradient Glow Border */}
// //                 <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

// //                 {/* MAIN NAVBAR */}
// //                 <nav
// //                   className={`
// //                 relative rounded-full
// //                 backdrop-blur-xl
// //                 transition-all duration-500
// //                 ${
// //                   scrolled
// //                     ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
// //                     : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
// //                 }
// //               `}
// //                 >
// //                   <div className="flex items-center justify-between px-8 py-3">

// //                     {/* LOGO */}
// //                     <div
// //                       onClick={() => navigate("/")}
// //                       className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// //                     >
// //                       <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// //                         <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// //                         <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// //                         <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// //                       </div>
// //                       <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// //                         urident
// //                       </span>
// //                     </div>

// //                     {/* DESKTOP NAV */}
// //                     <ul className="hidden md:flex flex-grow justify-center gap-8">
// //                       {navItems.map((item, index) => (
// //                         <li key={index}>
// //                           <button
// //                             onClick={() =>
// //                               handleNavigation(item.path, item.sectionId)
// //                             }
// //                             className="relative text-[#141414] font-medium text-[16px]
// //                         transition-all duration-300
// //                         hover:text-[#CB9F47]
// //                         after:absolute after:left-1/2 after:-bottom-1
// //                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
// //                         after:transition-all after:duration-300
// //                         after:-translate-x-1/2 hover:after:w-full"
// //                           >
// //                             {item.name}
// //                           </button>
// //                         </li>
// //                       ))}
// //                     </ul>

// //                     {/* DESKTOP CTA */}
// //                     <div className="hidden md:flex gap-4 items-center">

// //                       <button
// //                         onClick={() => navigate("/portal")}
// //                         className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
// //                     transition-all duration-300
// //                     hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
// //                     active:scale-95"
// //                       >
// //                         Explore Jurident
// //                       </button>

// //                       <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
// //                         <button
// //                           onClick={() => navigate("/demo")}
// //                           className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
// //                       transition-all duration-300 ease-in-out
// //                       hover:bg-transparent hover:text-white"
// //                         >
// //                           Book Demo
// //                         </button>
// //                       </div>
// //                     </div>

// //                     {/* MOBILE TOGGLE */}
// //                     <div className="md:hidden">
// //                       <button onClick={() => setIsOpen(!isOpen)}>
// //                         {isOpen ? (
// //                           <HiOutlineX className="w-6 h-6" />
// //                         ) : (
// //                           <HiOutlineMenu className="w-6 h-6" />
// //                         )}
// //                       </button>
// //                     </div>

// //                   </div>
// //                 </nav>
// //               </div>
// //             </div>
// //           </div>

// //           {/* MOBILE MENU */}
// //           {isOpen && (
// //             <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
// //               <div className="px-6 py-6">
// //                 <ul className="flex flex-col gap-4">
// //                   {navItems.map((item, index) => (
// //                     <li key={index}>
// //                       <button
// //                         onClick={() =>
// //                           handleNavigation(item.path, item.sectionId)
// //                         }
// //                         className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
// //                       >
// //                         {item.name}
// //                       </button>
// //                     </li>
// //                   ))}
// //                 </ul>

// //                 <div className="mt-6 flex flex-col gap-4 items-center">
// //                   <button
// //                     onClick={() => navigate("/portal")}
// //                     className="bg-black text-white py-3 rounded-full w-4/5"
// //                   >
// //                     Explore Jurident
// //                   </button>

// //                   <button
// //                     onClick={() => {
// //                       navigate("/demo");
// //                       setIsOpen(false);
// //                     }}
// //                     className="border py-3 rounded-full w-4/5 text-[#23216E]"
// //                   >
// //                     Book Demo
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </>
// //       ) : (
// //         <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50">
// //           <button
// //             onClick={scrollToTop}
// //             className="bg-white shadow-lg rounded-full p-3 hover:scale-110 transition"
// //           >
// //             <HiArrowUp className="w-5 h-5" />
// //           </button>
// //         </div>
// //       )}

// //       <style>{`
// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //         .animate-slideDown {
// //           animation: slideDown 0.35s ease-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // }
















// // import React, { useState, useEffect, useRef } from "react";
// // import Circle from "../assets/Vector-1.svg";
// // import Collar from "../assets/Rectangle(1).png";
// // import J from "../assets/Vector.svg";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { HiOutlineMenu, HiOutlineX, HiArrowUp } from "react-icons/hi";

// // export default function Navbar() {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const isHomePage = location.pathname === "/";

// //   const [isOpen, setIsOpen] = useState(false);
// //   const [showNavbar, setShowNavbar] = useState(true);
// //   const [scrolled, setScrolled] = useState(false);

// //   const lastScrollY = useRef(0);
// //   const NAVBAR_HEIGHT = 80;

// //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// //   useEffect(() => {

// //     // Disable navbar behavior on other pages
// //     if (!isHomePage) return;

// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;

// //       setScrolled(currentScrollY > 20);

// //       if (currentScrollY < 10) {
// //         setShowNavbar(true);
// //       } else if (currentScrollY > lastScrollY.current) {
// //         setShowNavbar(false);
// //         setIsOpen(false);
// //       } else {
// //         setShowNavbar(true);
// //       }

// //       lastScrollY.current = currentScrollY;
// //     };

// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);

// //   }, [isHomePage]);

// //   /* ---------------- SCROLL TO TOP ---------------- */
// //   const scrollToTop = () => {
// //     window.scrollTo({
// //       top: 0,
// //       behavior: "smooth",
// //     });
// //   };

// //   /* ---------------- SMOOTH SCROLL ---------------- */
// //   const scrollToSection = (sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) {
// //       const elementPosition =
// //         element.getBoundingClientRect().top + window.pageYOffset;
// //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// //       window.scrollTo({
// //         top: offsetPosition,
// //         behavior: "smooth",
// //       });
// //     }
// //   };

// //   const handleNavigation = (path, sectionId = null) => {
// //     if (sectionId) {
// //       if (location.pathname !== "/") {
// //         navigate("/");
// //         setTimeout(() => scrollToSection(sectionId), 150);
// //       } else {
// //         scrollToSection(sectionId);
// //       }
// //     } else {
// //       navigate(path);
// //     }
// //     setIsOpen(false);
// //   };

// //   const navItems = [
// //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// //     { name: "About Us", path: "/aboutUs" },
// //     { name: "AI Drafting", path: "/aiDrafting" },
// //     { name: "Subscription", path: "/subPlans" },
// //     { name: "Help", path: "/", sectionId: "help" },
// //   ];

// //   return (
// //     <>
// //       {isHomePage ? (
// //         <>
// //           {/* FLOATING WRAPPER */}
// //           <div
// //             className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
// //             ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
// //           >
// //             <div className="px-4 sm:px-6">
// //               <div className="mx-auto max-w-[1300px] relative">

// //                 {/* Gradient Glow Border */}
// //                 <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

// //                 {/* MAIN NAVBAR */}
// //                 <nav
// //                   className={`
// //                     relative rounded-full
// //                     backdrop-blur-xl
// //                     transition-all duration-500
// //                     ${
// //                       scrolled
// //                         ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
// //                         : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
// //                     }
// //                   `}
// //                 >
// //                   <div className="flex items-center justify-between px-8 py-3">

// //                     {/* LOGO */}
// //                     <div
// //                       onClick={() => navigate("/")}
// //                       className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// //                     >
// //                       <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// //                         <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// //                         <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// //                         <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// //                       </div>
// //                       <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// //                         urident
// //                       </span>
// //                     </div>

// //                     {/* DESKTOP NAV */}
// //                     <ul className="hidden md:flex flex-grow justify-center gap-8">
// //                       {navItems.map((item, index) => (
// //                         <li key={index}>
// //                           <button
// //                             onClick={() =>
// //                               handleNavigation(item.path, item.sectionId)
// //                             }
// //                             className="relative text-[#141414] font-medium text-[16px]
// //                             transition-all duration-300
// //                             hover:text-[#CB9F47]
// //                             after:absolute after:left-1/2 after:-bottom-1
// //                             after:h-[2px] after:w-0 after:bg-[#CB9F47]
// //                             after:transition-all after:duration-300
// //                             after:-translate-x-1/2 hover:after:w-full"
// //                           >
// //                             {item.name}
// //                           </button>
// //                         </li>
// //                       ))}
// //                     </ul>

// //                     {/* DESKTOP CTA */}
// //                     <div className="hidden md:flex gap-4 items-center">

// //                       <button
// //                         onClick={() => navigate("/portal")}
// //                         className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
// //                         transition-all duration-300
// //                         hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
// //                         active:scale-95"
// //                       >
// //                         Explore Jurident
// //                       </button>

// //                       <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
// //                         <button
// //                           onClick={() => navigate("/demo")}
// //                           className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
// //                           transition-all duration-300 ease-in-out
// //                           hover:bg-transparent hover:text-white"
// //                         >
// //                           Book Demo
// //                         </button>
// //                       </div>
// //                     </div>

// //                     {/* MOBILE TOGGLE */}
// //                     <div className="md:hidden">
// //                       <button onClick={() => setIsOpen(!isOpen)}>
// //                         {isOpen ? (
// //                           <HiOutlineX className="w-6 h-6" />
// //                         ) : (
// //                           <HiOutlineMenu className="w-6 h-6" />
// //                         )}
// //                       </button>
// //                     </div>

// //                   </div>
// //                 </nav>
// //               </div>
// //             </div>
// //           </div>

// //           {/* MOBILE MENU */}
// //           {isOpen && (
// //             <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
// //               <div className="px-6 py-6">
// //                 <ul className="flex flex-col gap-4">
// //                   {navItems.map((item, index) => (
// //                     <li key={index}>
// //                       <button
// //                         onClick={() =>
// //                           handleNavigation(item.path, item.sectionId)
// //                         }
// //                         className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
// //                       >
// //                         {item.name}
// //                       </button>
// //                     </li>
// //                   ))}
// //                 </ul>

// //                 <div className="mt-6 flex flex-col gap-4 items-center">
// //                   <button
// //                     onClick={() => navigate("/portal")}
// //                     className="bg-black text-white py-3 rounded-full w-4/5"
// //                   >
// //                     Explore Jurident
// //                   </button>

// //                   <button
// //                     onClick={() => {
// //                       navigate("/demo");
// //                       setIsOpen(false);
// //                     }}
// //                     className="border py-3 rounded-full w-4/5 text-[#23216E]"
// //                   >
// //                     Book Demo
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </>
// //       ) : (
// //         <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50">
// //           <button
// //             onClick={scrollToTop}
// //             className="bg-white shadow-lg rounded-full p-3 hover:scale-110 transition"
// //           >
// //             <HiArrowUp className="w-5 h-5" />
// //           </button>
// //         </div>
// //       )}

// //       <style>{`
// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //         .animate-slideDown {
// //           animation: slideDown 0.35s ease-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // }























// // //final code
// // import React, { useState, useEffect, useRef } from "react";
// // import Circle from "../assets/Vector-1.svg";
// // import Collar from "../assets/Rectangle(1).png";
// // import J from "../assets/Vector.svg";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// // export default function Navbar() {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [isOpen, setIsOpen] = useState(false);
// //   const [showNavbar, setShowNavbar] = useState(true);
// //   const [scrolled, setScrolled] = useState(false);

// //   const lastScrollY = useRef(0);
// //   const NAVBAR_HEIGHT = 80;

// //   /* ---------------- SCROLL BEHAVIOR ---------------- */
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;

// //       setScrolled(currentScrollY > 20);

// //       if (currentScrollY < 10) {
// //         setShowNavbar(true);
// //       } else if (currentScrollY > lastScrollY.current) {
// //         setShowNavbar(false);
// //         setIsOpen(false);
// //       } else {
// //         setShowNavbar(true);
// //       }

// //       lastScrollY.current = currentScrollY;
// //     };

// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   /* ---------------- SMOOTH SCROLL ---------------- */
// //   const scrollToSection = (sectionId) => {
// //     const element = document.getElementById(sectionId);
// //     if (element) {
// //       const elementPosition =
// //         element.getBoundingClientRect().top + window.pageYOffset;
// //       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

// //       window.scrollTo({
// //         top: offsetPosition,
// //         behavior: "smooth",
// //       });
// //     }
// //   };

// //   const handleNavigation = (path, sectionId = null) => {
// //     if (sectionId) {
// //       if (location.pathname !== "/") {
// //         navigate("/");
// //         setTimeout(() => scrollToSection(sectionId), 150);
// //       } else {
// //         scrollToSection(sectionId);
// //       }
// //     } else {
// //       navigate(path);
// //     }
// //     setIsOpen(false);
// //   };

// //   const navItems = [
// //     { name: "Why Jurident?", path: "/", sectionId: "features" },
// //     { name: "About Us", path: "/aboutUs" },
// //     { name: "AI Drafting", path: "/aiDrafting" },
// //     { name: "Subscription", path: "/subPlans" },
// //     { name: "Help", path: "/", sectionId: "help" },
// //   ];

// //   return (
// //     <>
// //       {/* FLOATING WRAPPER */}
// //       <div
// //         className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
// //         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
// //       >
// //         <div className="px-4 sm:px-6">
// //           <div className="mx-auto max-w-[1300px] relative">

// //             {/* Gradient Glow Border */}
// //             <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

// //             {/* MAIN NAVBAR */}
// //             <nav
// //               className={`
// //                 relative rounded-full
// //                 backdrop-blur-xl
// //                 transition-all duration-500
// //                 ${
// //                   scrolled
// //                     ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
// //                     : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
// //                 }
// //               `}
// //             >
// //               <div className="flex items-center justify-between px-8 py-3">

// //                 {/* LOGO */}
// //                 <div
// //                   onClick={() => navigate("/")}
// //                   className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
// //                 >
// //                   <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
// //                     <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
// //                     <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
// //                     <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
// //                   </div>
// //                   <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
// //                     urident
// //                   </span>
// //                 </div>

// //                 {/* DESKTOP NAV */}
// //                 <ul className="hidden md:flex flex-grow justify-center gap-8">
// //                   {navItems.map((item, index) => (
// //                     <li key={index}>
// //                       <button
// //                         onClick={() =>
// //                           handleNavigation(item.path, item.sectionId)
// //                         }
// //                         className="relative text-[#141414] font-medium text-[16px]
// //                         transition-all duration-300
// //                         hover:text-[#CB9F47]
// //                         after:absolute after:left-1/2 after:-bottom-1
// //                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
// //                         after:transition-all after:duration-300
// //                         after:-translate-x-1/2 hover:after:w-full"
// //                       >
// //                         {item.name}
// //                       </button>
// //                     </li>
// //                   ))}
// //                 </ul>

// //                 {/* DESKTOP CTA */}
// //                 <div className="hidden md:flex gap-4 items-center">

// //                   <button
// //                     onClick={() => navigate("/portal")}
// //                     className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
// //                     transition-all duration-300
// //                     hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
// //                     active:scale-95"
// //                   >
// //                     Explore Jurident
// //                   </button>

// //                   {/* ONLY TRANSITION ADDED HERE */}
// //                   <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
// //                     <button
// //                       onClick={() => navigate("/demo")}
// //                       className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
// //                       transition-all duration-300 ease-in-out
// //                       hover:bg-transparent hover:text-white"
// //                     >
// //                       Book Demo
// //                     </button>
// //                   </div>
// //                 </div>

// //                 {/* MOBILE TOGGLE */}
// //                 <div className="md:hidden">
// //                   <button onClick={() => setIsOpen(!isOpen)}>
// //                     {isOpen ? (
// //                       <HiOutlineX className="w-6 h-6" />
// //                     ) : (
// //                       <HiOutlineMenu className="w-6 h-6" />
// //                     )}
// //                   </button>
// //                 </div>

// //               </div>
// //             </nav>
// //           </div>
// //         </div>
// //       </div>

// //       {/* MOBILE MENU */}
// //       {isOpen && (
// //         <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
// //           <div className="px-6 py-6">
// //             <ul className="flex flex-col gap-4">
// //               {navItems.map((item, index) => (
// //                 <li key={index}>
// //                   <button
// //                     onClick={() =>
// //                       handleNavigation(item.path, item.sectionId)
// //                     }
// //                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
// //                   >
// //                     {item.name}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>

// //             <div className="mt-6 flex flex-col gap-4 items-center">
// //               <button
// //                 onClick={() => navigate("/portal")}
// //                 className="bg-black text-white py-3 rounded-full w-4/5"
// //               >
// //                 Explore Jurident
// //               </button>

// //               <button
// //                 onClick={() => {
// //                   navigate("/demo");
// //                   setIsOpen(false);
// //                 }}
// //                 className="border py-3 rounded-full w-4/5 text-[#23216E]"
// //               >
// //                 Book Demo
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <style>{`
// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }
// //         .animate-slideDown {
// //           animation: slideDown 0.35s ease-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // }














// //final code
// import React, { useState, useEffect, useRef } from "react";
// import Circle from "../assets/Vector-1.svg";
// import Collar from "../assets/Rectangle(1).png";
// import J from "../assets/Vector.svg";
// import { useNavigate, useLocation } from "react-router-dom";
// import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [isOpen, setIsOpen] = useState(false);
//   const [showNavbar, setShowNavbar] = useState(true);
//   const [scrolled, setScrolled] = useState(false);

//   const lastScrollY = useRef(0);
//   const NAVBAR_HEIGHT = 80;

//   /* ---------------- SCROLL BEHAVIOR ---------------- */
//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       setScrolled(currentScrollY > 20);

//       // Navbar only visible at top
//       if (currentScrollY < 10) {
//         setShowNavbar(true);
//       } else {
//         setShowNavbar(false);
//         setIsOpen(false);
//       }

//       lastScrollY.current = currentScrollY;
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   /* ---------------- SMOOTH SCROLL ---------------- */
//   const scrollToSection = (sectionId) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       const elementPosition =
//         element.getBoundingClientRect().top + window.pageYOffset;
//       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth",
//       });
//     }
//   };

//   const handleNavigation = (path, sectionId = null) => {
//     if (sectionId) {
//       if (location.pathname !== "/") {
//         navigate("/");
//         setTimeout(() => scrollToSection(sectionId), 150);
//       } else {
//         scrollToSection(sectionId);
//       }
//     } else {
//       navigate(path);
//     }
//     setIsOpen(false);
//   };

//   const navItems = [
//     { name: "Why Jurident?", path: "/", sectionId: "features" },
//     { name: "About Us", path: "/aboutUs" },
//     { name: "AI Drafting", path: "/aiDrafting" },
//     { name: "Subscription", path: "/subPlans" },
//     { name: "Help", path: "/", sectionId: "help" },
//   ];

//   return (
//     <>
//       {/* FLOATING WRAPPER */}
//       <div
//         className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
//         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
//       >
//         <div className="px-4 sm:px-6">
//           <div className="mx-auto max-w-[1300px] relative">

//             {/* Gradient Glow Border */}
//             <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

//             {/* MAIN NAVBAR */}
//             <nav
//               className={`
//                 relative rounded-full
//                 backdrop-blur-xl
//                 transition-all duration-500
//                 ${
//                   scrolled
//                     ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
//                     : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
//                 }
//               `}
//             >
//               <div className="flex items-center justify-between px-8 py-3">

//                 {/* LOGO */}
//                 <div
//                   onClick={() => navigate("/")}
//                   className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
//                 >
//                   <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
//                     <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
//                     <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
//                     <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
//                   </div>
//                   <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
//                     urident
//                   </span>
//                 </div>

//                 {/* DESKTOP NAV */}
//                 <ul className="hidden md:flex flex-grow justify-center gap-8">
//                   {navItems.map((item, index) => (
//                     <li key={index}>
//                       <button
//                         onClick={() =>
//                           handleNavigation(item.path, item.sectionId)
//                         }
//                         className="relative text-[#141414] font-medium text-[16px]
//                         transition-all duration-300
//                         hover:text-[#CB9F47]
//                         after:absolute after:left-1/2 after:-bottom-1
//                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
//                         after:transition-all after:duration-300
//                         after:-translate-x-1/2 hover:after:w-full"
//                       >
//                         {item.name}
//                       </button>
//                     </li>
//                   ))}
//                 </ul>

//                 {/* DESKTOP CTA */}
//                 <div className="hidden md:flex gap-4 items-center">

//                   <button
//                     onClick={() => navigate("/portal")}
//                     className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
//                     transition-all duration-300
//                     hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
//                     active:scale-95"
//                   >
//                     Explore Jurident
//                   </button>

//                   <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
//                     <button
//                       onClick={() => navigate("/demo")}
//                       className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
//                       transition-all duration-300 ease-in-out
//                       hover:bg-transparent hover:text-white"
//                     >
//                       Book Demo
//                     </button>
//                   </div>
//                 </div>

//                 {/* MOBILE TOGGLE */}
//                 <div className="md:hidden">
//                   <button onClick={() => setIsOpen(!isOpen)}>
//                     {isOpen ? (
//                       <HiOutlineX className="w-6 h-6" />
//                     ) : (
//                       <HiOutlineMenu className="w-6 h-6" />
//                     )}
//                   </button>
//                 </div>

//               </div>
//             </nav>
//           </div>
//         </div>
//       </div>

//       {/* MOBILE MENU */}
//       {isOpen && (
//         <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
//           <div className="px-6 py-6">
//             <ul className="flex flex-col gap-4">
//               {navItems.map((item, index) => (
//                 <li key={index}>
//                   <button
//                     onClick={() =>
//                       handleNavigation(item.path, item.sectionId)
//                     }
//                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
//                   >
//                     {item.name}
//                   </button>
//                 </li>
//               ))}
//             </ul>

//             <div className="mt-6 flex flex-col gap-4 items-center">
//               <button
//                 onClick={() => navigate("/portal")}
//                 className="bg-black text-white py-3 rounded-full w-4/5"
//               >
//                 Explore Jurident
//               </button>

//               <button
//                 onClick={() => {
//                   navigate("/demo");
//                   setIsOpen(false);
//                 }}
//                 className="border py-3 rounded-full w-4/5 text-[#23216E]"
//               >
//                 Book Demo
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-slideDown {
//           animation: slideDown 0.35s ease-out;
//         }
//       `}</style>
//     </>
//   );
// }



























// //final code
// import React, { useState, useEffect, useRef } from "react";
// import Circle from "../assets/Vector-1.svg";
// import Collar from "../assets/Rectangle(1).png";
// import J from "../assets/Vector.svg";
// import { useNavigate, useLocation } from "react-router-dom";
// import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [isOpen, setIsOpen] = useState(false);
//   const [showNavbar, setShowNavbar] = useState(true);
//   const [scrolled, setScrolled] = useState(false);

//   const lastScrollY = useRef(0);
//   const NAVBAR_HEIGHT = 80;

//   /* ---------------- SCROLL BEHAVIOR ---------------- */
//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       setScrolled(currentScrollY > 20);

//       // Navbar only visible at top
//       if (currentScrollY < 10) {
//         setShowNavbar(true);
//       } else {
//         setShowNavbar(false);
//         setIsOpen(false);
//       }

//       lastScrollY.current = currentScrollY;
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   /* ---------------- SMOOTH SCROLL ---------------- */
//   const scrollToSection = (sectionId) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       const elementPosition =
//         element.getBoundingClientRect().top + window.pageYOffset;
//       const offsetPosition = elementPosition - NAVBAR_HEIGHT;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth",
//       });
//     }
//   };

//   const handleNavigation = (path, sectionId = null) => {
//     if (sectionId) {
//       if (location.pathname !== "/") {
//         navigate("/");
//         setTimeout(() => scrollToSection(sectionId), 150);
//       } else {
//         scrollToSection(sectionId);
//       }
//     } else {
//       navigate(path);
//     }
//     setIsOpen(false);
//   };

//   const navItems = [
//     { name: "Why Jurident?", path: "/", sectionId: "features" },
//     { name: "About Us", path: "/aboutUs" },
//     { name: "AI Drafting", path: "/aiDrafting" },
//     { name: "Subscription", path: "/subPlans" },
//     { name: "Help", path: "/", sectionId: "help" },
//   ];

//   return (
//     <>
//       {/* FLOATING WRAPPER */}
//       <div
//         className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
//         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
//       >
//         <div className="px-4 sm:px-6">
//           <div className="mx-auto max-w-[1300px] relative">

//             {/* Gradient Glow Border */}
//             <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

//             {/* MAIN NAVBAR */}
//             <nav
//               className={`
//                 relative rounded-full
//                 backdrop-blur-xl
//                 transition-all duration-500
//                 ${
//                   scrolled
//                     ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
//                     : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
//                 }
//               `}
//             >
//               <div className="flex items-center justify-between px-8 py-3">

//                 {/* LOGO */}
//                 <div
//                   onClick={() => navigate("/")}
//                   className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
//                 >
//                   <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
//                     <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
//                     <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
//                     <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
//                   </div>
//                   <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
//                     urident
//                   </span>
//                 </div>

//                 {/* DESKTOP NAV */}
//                 <ul className="hidden md:flex flex-grow justify-center gap-8">
//                   {navItems.map((item, index) => (
//                     <li key={index}>
//                       <button
//                         onClick={() =>
//                           handleNavigation(item.path, item.sectionId)
//                         }
//                         className="relative text-[#141414] font-medium text-[16px]
//                         transition-all duration-300
//                         hover:text-[#CB9F47]
//                         after:absolute after:left-1/2 after:-bottom-1
//                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
//                         after:transition-all after:duration-300
//                         after:-translate-x-1/2 hover:after:w-full"
//                       >
//                         {item.name}
//                       </button>
//                     </li>
//                   ))}
//                 </ul>

//                 {/* DESKTOP CTA */}
//                 <div className="hidden md:flex gap-4 items-center">

//                   <button
//                     onClick={() => navigate("/portal")}
//                     className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
//                     transition-all duration-300
//                     hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
//                     active:scale-95"
//                   >
//                     Explore Jurident
//                   </button>

//                   <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
//                     <button
//                       onClick={() => navigate("/demo")}
//                       className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
//                       transition-all duration-300 ease-in-out
//                       hover:bg-transparent hover:text-white"
//                     >
//                       Book Demo
//                     </button>
//                   </div>
//                 </div>

//                 {/* MOBILE TOGGLE */}
//                 <div className="md:hidden">
//                   <button onClick={() => setIsOpen(!isOpen)}>
//                     {isOpen ? (
//                       <HiOutlineX className="w-6 h-6" />
//                     ) : (
//                       <HiOutlineMenu className="w-6 h-6" />
//                     )}
//                   </button>
//                 </div>

//               </div>
//             </nav>
//           </div>
//         </div>
//       </div>

//       {/* MOBILE MENU */}
//       {isOpen && (
//         <div className="fixed top-[110px] left-4 right-4 backdrop-blur-2xl bg-white/85 shadow-[0_30px_80px_rgba(0,0,0,0.2)] rounded-3xl z-40 md:hidden animate-slideDown">
//           <div className="px-6 py-6">
//             <ul className="flex flex-col gap-4">
//               {navItems.map((item, index) => (
//                 <li key={index}>
//                   <button
//                     onClick={() =>
//                       handleNavigation(item.path, item.sectionId)
//                     }
//                     className="w-full py-3 rounded-xl text-lg font-medium hover:bg-black/5 transition"
//                   >
//                     {item.name}
//                   </button>
//                 </li>
//               ))}
//             </ul>

//             <div className="mt-6 flex flex-col gap-4 items-center">
//               <button
//                 onClick={() => navigate("/portal")}
//                 className="bg-black text-white py-3 rounded-full w-4/5"
//               >
//                 Explore Jurident
//               </button>

//               <button
//                 onClick={() => {
//                   navigate("/demo");
//                   setIsOpen(false);
//                 }}
//                 className="border py-3 rounded-full w-4/5 text-[#23216E]"
//               >
//                 Book Demo
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-slideDown {
//           animation: slideDown 0.35s ease-out;
//         }
//       `}</style>
//     </>
//   );
// }
















// //final code
// import React, { useState, useEffect, useRef } from "react";
// import Circle from "../assets/Vector-1.svg";
// import Collar from "../assets/Rectangle(1).png";
// import J from "../assets/Vector.svg";
// import { useNavigate, useLocation } from "react-router-dom";
// import { HiOutlineMenu, HiOutlineX, HiArrowUp } from "react-icons/hi";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isOpen, setIsOpen] = useState(false);
//   const [showNavbar, setShowNavbar] = useState(true);
//   const [scrolled, setScrolled] = useState(false);
//   const [showArrow, setShowArrow] = useState(false);
//   const lastScrollY = useRef(0);

//   /* ---------------- SCROLL BEHAVIOR ---------------- */
//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       setScrolled(currentScrollY > 20);

//       if (currentScrollY < 10) {
//         setShowNavbar(true);
//         setShowArrow(false);
//       } else {
//         setShowNavbar(false);

//         if (currentScrollY < lastScrollY.current) {
//           setShowArrow(true); // scrolling up
//         } else {
//           setShowArrow(false); // scrolling down
//         }

//         setIsOpen(false);
//       }

//       lastScrollY.current = currentScrollY;
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   /* ---------------- SCROLL TO TOP ---------------- */
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   /* ---------------- SMOOTH SCROLL ---------------- */
//   const scrollToSection = (sectionId) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
//       const offsetPosition = elementPosition - NAVBAR_HEIGHT;
//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth",
//       });
//     }
//   };

//   const handleNavigation = (path, sectionId = null) => {
//     if (sectionId) {
//       if (location.pathname !== "/") {
//         navigate("/");
//         setTimeout(() => scrollToSection(sectionId), 150); // Wait for navigation
//       } else {
//         scrollToSection(sectionId);
//       }
//     } else {
//       navigate(path);
//     }
//     setIsOpen(false); // Close mobile menu
//   };
// const navItems = [
//   { name: "Why Jurident?", path: "/", sectionId: "features" },
//   { name: "About Us", path: "/aboutUs" },
//   { name: "AI Drafting", path: "/aiDrafting" },
//   { name: "Advocate", path: "/advocate" },
//   { name: "Enterprise", path: "/enterprise" },
//    { name: "Careers", path: "Careers" }, 
//   { name: "Help", path: "/", sectionId: "help" },
// ];

//   return (
//     <>
//       {/* FLOATING WRAPPER */}
//       <div
//         className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
//         ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
//       >
//         <div className="px-4 sm:px-6">
//           <div className="mx-auto max-w-[1300px] relative">

//             {/* Gradient Glow Border */}
//             <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

//             {/* MAIN NAVBAR */}
//             <nav
//               className={`
//                 relative rounded-full
//                 backdrop-blur-xl
//                 transition-all duration-500
//                 ${
//                   scrolled
//                     ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
//                     : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
//                 }
//               `}
//             >
//               <div className="flex items-center justify-between px-8 py-3">

//                 {/* LOGO */}
//                 <div
//                   onClick={() => navigate("/")}
//                   className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
//                 >
//                   <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
//                     <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
//                     <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
//                     <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
//                   </div>
//                   <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
//                     urident
//                   </span>
//                 </div>

//                 {/* DESKTOP NAV */}
//                 <ul className="hidden md:flex flex-grow justify-center gap-8">
//                   {navItems.map((item, index) => (
//                     <li key={index}>
//                       <button
//                         onClick={() =>
//                           handleNavigation(item.path, item.sectionId)
//                         }
//                         className="relative text-[#141414] font-medium text-[16px]
//                         transition-all duration-300
//                         hover:text-[#CB9F47]
//                         after:absolute after:left-1/2 after:-bottom-1
//                         after:h-[2px] after:w-0 after:bg-[#CB9F47]
//                         after:transition-all after:duration-300
//                         after:-translate-x-1/2 hover:after:w-full"
//                       >
//                         {item.name}
//                       </button>
//                     </li>
//                   ))}
//                 </ul>

//                 {/* DESKTOP CTA */}
//                 <div className="hidden md:flex gap-4 items-center">

//                   <button
//                     onClick={() => navigate("/portal")}
//                     className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
//                     transition-all duration-300
//                     hover:scale-105 hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
//                     active:scale-95"
//                   >
//                     Explore Jurident
//                   </button>

//                   <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
//                     {/* <button
//                       onClick={() => navigate("/demo")}
//                       className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
//                       transition-all duration-300 ease-in-out
//                       "
//                     >
//                       Book Demo
//                     </button> */}
//                     <div
//   className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]
//   transition-transform duration-300 ease-in-out hover:scale-105  hover:shadow-[0_10px_25px_rgba(0,0,0,0.2)]"
// >
//   <button
//     onClick={() => navigate("/demo")}
//     className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm"
//   >
//     Book Demo
//   </button>
// </div>
//                   </div>
//                 </div>

//                 {/* MOBILE TOGGLE */}
//                 <div className="md:hidden">
//                   <button onClick={() => setIsOpen(!isOpen)}>
//                     {isOpen ? (
//                       <HiOutlineX className="w-6 h-6" />
//                     ) : (
//                       <HiOutlineMenu className="w-6 h-6" />
//                     )}
//                   </button>
//                 </div>

//               </div>
//             </nav>
//           </div>
//         </div>
//       </div>

     
//     {/* SCROLL TO TOP ARROW */}
// {showArrow && (
//  <button
//   onClick={scrollToTop}
//   className="fixed bottom-6 right-6 z-50 bg-black text-white p-3 rounded-full shadow-lg hover:scale-110 transition"
// >
//   <HiArrowUp className="w-5 h-5" />
// </button>
// )}

//       {/* MOBILE MENU */}
//    {isOpen && (
//   <div className="fixed inset-0 z-50 md:hidden">

//     {/* BACKDROP */}
//     <div
//       className="absolute inset-0 bg-black/40 backdrop-blur-sm"
//       onClick={() => setIsOpen(false)}
//     />

//     {/* SIDE PANEL - reduced width and padding */}
//     <div className="absolute top-0 left-0 h-full w-[65%] max-w-[260px]
//       bg-white shadow-[0_20px_60px_rgba(0,0,0,0.25)]
//       rounded-r-3xl p-4 flex flex-col
//       animate-slideIn"
//     >

//       {/* HEADER */}
//       <div className="flex items-center justify-between mb-5">
//         <span className="text-[18px] font-bold text-[#CB9F47]">
//           Jurident
//         </span>
//         <button onClick={() => setIsOpen(false)}>
//           <HiOutlineX className="w-5 h-5 text-gray-500" />
//         </button>
//       </div>

//       {/* NAV ITEMS */}
//       <div className="flex flex-col gap-1">
//         {navItems.map((item, index) => (
//           <button
//             key={index}
//             onClick={() => handleNavigation(item.path, item.sectionId)}
//             className="text-left px-3 py-2 rounded-xl
//             text-[14px] font-medium text-[#222]
//             transition-all duration-300
//             hover:bg-[#CB9F47]/10 hover:text-[#CB9F47]
//             active:scale-[0.97]"
//           >
//             {item.name}
//           </button>
//         ))}
//       </div>

//      {/* CTA BUTTONS */}
// <div className="mt-4 flex flex-col gap-2 pt-4">

//         <button
//           onClick={() => { navigate("/portal"); setIsOpen(false); }}
//           className="w-full py-2.5 rounded-full 
//           bg-black text-white font-semibold text-[13px]
//           transition-all duration-300
//           hover:scale-105 active:scale-95"
//         >
//           Explore →
//         </button>

//         <div className="w-full inline-flex rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] p-[1px]
//           transition-all duration-300 hover:scale-105">
//           <button
//             onClick={() => { navigate("/demo"); setIsOpen(false); }}
//             className="w-full flex items-center justify-center 
//             bg-white text-black py-2.5 rounded-full font-semibold text-[13px]"
//           >
//             Book Demo
//           </button>
//         </div>

//       </div>
//     </div>
//   </div>
// )}
//       <style>{`
//  @keyframes slideIn {
//   from {
//     transform: translateX(-100%);
//     opacity: 0.6;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// }

// .animate-slideIn {
//   animation: slideIn 0.35s ease-out;
// }
//       `}</style>
//     </>
//   );
// }






















//final code
import React, { useState, useEffect, useRef } from "react";
import Circle from "../assets/Vector-1.svg";
import Collar from "../assets/Rectangle(1).png";
import J from "../assets/Vector.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX, HiArrowUp } from "react-icons/hi";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [showArrow, setShowArrow] = useState(false);

  const lastScrollY = useRef(0);
  const NAVBAR_HEIGHT = 80;

  /* ---------------- SCROLL BEHAVIOR ---------------- */
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > 20);

      if (currentScrollY < 10) {
        setShowNavbar(true);
        setShowArrow(false);
      } else {
        setShowNavbar(false);

        if (currentScrollY < lastScrollY.current) {
          setShowArrow(true); // scrolling up
        } else {
          setShowArrow(false); // scrolling down
        }

        setIsOpen(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ---------------- SCROLL TO TOP ---------------- */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* ---------------- SMOOTH SCROLL ---------------- */
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - NAVBAR_HEIGHT;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleNavigation = (path, sectionId = null) => {
    if (sectionId) {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => scrollToSection(sectionId), 150);
      } else {
        scrollToSection(sectionId);
      }
    } else {
      navigate(path);
    }
    setIsOpen(false);
  };
const navItems = [
  { name: "Why Jurident?", path: "/", sectionId: "features" },
  { name: "About Us", path: "/aboutUs" },
  { name: "AI Drafting", path: "/aiDrafting" },
  { name: "Advocate", path: "/advocate" },
  { name: "Enterprise", path: "/enterprise" },
   { name: "Careers", path: "Careers" },
  { name: "New UI", path: "/new-ui" },
  { name: "Help", path: "/", sectionId: "help" },
];

  return (
    <>
      {/* FLOATING WRAPPER */}
      <div
        className={`fixed top-5 left-0 w-full z-50 transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]
        ${showNavbar ? "translate-y-0 opacity-100" : "-translate-y-24 opacity-0"}`}
      >
        <div className="px-4 sm:px-6">
          <div className="mx-auto max-w-[1300px] relative">

            {/* Gradient Glow Border */}
            <div className="absolute inset-0 rounded-full p-[1px] bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] opacity-60 blur-sm"></div>

            {/* MAIN NAVBAR */}
            <nav
              className={`
                relative rounded-full
                backdrop-blur-xl
                transition-all duration-500
                ${
                  scrolled
                    ? "bg-white shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
                    : "bg-white/90 shadow-[0_8px_30px_rgba(0,0,0,0.10)]"
                }
              `}
            >
              <div className="flex items-center justify-between px-8 py-3">

                {/* LOGO */}
                <div
                  onClick={() => navigate("/")}
                  className="flex items-end gap-0.5 w-[135px] h-[52px] cursor-pointer group"
                >
                  <div className="relative w-[28px] h-[52px] transition-transform duration-300 group-hover:scale-105">
                    <img src={J} alt="J" className="absolute bottom-0 left-0 w-[28px]" />
                    <img src={Circle} alt="Circle" className="absolute top-0 left-[20%] w-[18px]" />
                    <img src={Collar} alt="Collar" className="absolute top-[6%] left-[20%] w-[18px]" />
                  </div>
                  <span className="text-[#CB9F47] font-semibold text-[28px] tracking-wide">
                    urident
                  </span>
                </div>

                {/* DESKTOP NAV */}
                <ul className="hidden xl:flex flex-grow justify-center gap-8">
                  {navItems.map((item, index) => (
                    <li key={index}>
                      <button
                        onClick={() =>
                          handleNavigation(item.path, item.sectionId)
                        }
                        className="relative text-[#141414] font-medium text-[16px]
                        transition-all duration-300
                        hover:text-[#CB9F47]
                        after:absolute after:left-1/2 after:-bottom-1
                        after:h-[2px] after:w-0 after:bg-[#CB9F47]
                        after:transition-all after:duration-300
                        after:-translate-x-1/2 hover:after:w-full"
                      >
                        {item.name}
                      </button>
                    </li>
                  ))}
                </ul>

                {/* DESKTOP CTA */}
                <div className="hidden xl:flex gap-4 items-center">

                  <button
                    onClick={() => navigate("/portal")}
                    className="bg-black text-white px-6 py-2.5 rounded-full font-medium text-sm
                    transition-all duration-300
                    hover:scale-105 hover:shadow-[0_10px_25px_rgba(0,0,0,0.25)]
                    active:scale-95"
                  >
                    Explore Jurident
                  </button>

                  <div className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]">
                    {/* <button
                      onClick={() => navigate("/demo")}
                      className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm
                      transition-all duration-300 ease-in-out
                      "
                    >
                      Book Demo
                    </button> */}
                    <div
  className="p-[1px] rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E]
  transition-transform duration-300 ease-in-out hover:scale-105  hover:shadow-[0_10px_25px_rgba(0,0,0,0.2)]"
>
  <button
    onClick={() => navigate("/demo")}
    className="bg-white text-black px-6 py-2.5 rounded-full font-medium text-sm"
  >
    Book Demo
  </button>
</div>
                  </div>
                </div>

                {/* MOBILE TOGGLE */}
                <div className="xl:hidden">
                  <button onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? (
                      <HiOutlineX className="w-6 h-6" />
                    ) : (
                      <HiOutlineMenu className="w-6 h-6" />
                    )}
                  </button>
                </div>

              </div>
            </nav>
          </div>
        </div>
      </div>

     
    {/* SCROLL TO TOP ARROW */}
{showArrow && (
 <button
  onClick={scrollToTop}
  className="fixed bottom-6 right-6 z-50 bg-black text-white p-3 rounded-full shadow-lg hover:scale-110 transition"
>
  <HiArrowUp className="w-5 h-5" />
</button>
)}

      {/* MOBILE MENU */}
   {isOpen && (
  <div className="fixed inset-0 z-50 xl:hidden">

    {/* BACKDROP */}
    <div
      className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      onClick={() => setIsOpen(false)}
    />

    {/* SIDE PANEL - reduced width and padding */}
    <div
  className="
    absolute top-0 right-0 h-full
    w-[78%] sm:w-[68%] lg:w-[48%] xl:w-[26%]
    max-w-[420px]
    bg-white
    shadow-[0_20px_60px_rgba(0,0,0,0.25)]
    rounded-l-3xl
    p-6 lg:p-8
    flex flex-col
    animate-slideInRight
  "
>

      {/* HEADER */}
      <div className="flex items-center justify-between mb-5 pl-3 ">
        <span className="text-[18px] lg:text-[26px] font-bold text-[#CB9F47]">
          Jurident
        </span>
        <button onClick={() => setIsOpen(false)}>
          <HiOutlineX className="w-5 h-5 lg:w-7 lg:h-7 text-gray-500" />
        </button>
      </div>

      {/* NAV ITEMS */}
      <div className="flex flex-col gap-2 lg:gap-3 mt-4">
        {navItems.map((item, index) => (
          <button
            key={index}
            onClick={() => handleNavigation(item.path, item.sectionId)}
            className="
text-left
px-4 lg:px-5
py-3 lg:py-4
rounded-xl
text-[15px] lg:text-[18px]
font-medium
text-[#222]
transition-all duration-300
hover:bg-[#CB9F47]/10
hover:text-[#CB9F47]
active:scale-[0.97]
"
          >
            {item.name}
          </button>
        ))}
      </div>

     {/* CTA BUTTONS */}
<div className="mt-4 flex flex-col gap-2 pt-4">

        <button
          onClick={() => { navigate("/portal"); setIsOpen(false); }}
          className="
w-full
py-3.5 lg:py-4
rounded-full
bg-black
text-white
font-semibold
text-[14px] lg:text-[16px]
transition-all duration-300
hover:scale-105
"
        >
          Explore →
        </button>

        <div className="w-full inline-flex rounded-full bg-gradient-to-r from-[#23216E] via-[#D0A95C] to-[#23216E] p-[1px]
          transition-all duration-300 hover:scale-105">
          <button
            onClick={() => { navigate("/demo"); setIsOpen(false); }}
            className="
w-full
flex
items-center
justify-center
bg-white
text-black
py-3.5 lg:py-4
rounded-full
font-semibold
text-[14px] lg:text-[16px]
"
          >
            Book Demo
          </button>
        </div>

      </div>
    </div>
  </div>
)}
      <style>{`
 @keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0.6;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-slideInRight {
  animation: slideInRight 0.35s ease-out;
}
      `}</style>
    </>
  );
}
